const generateTrackingValue = (data, eventText, options = {}) => {
  const {
    delimiter = "|",
    eventTextPrefix = false,
    // namespaceSuffix = false
  } = options;

  const namespace = "interactives";
  const type = data.type;

  const defaultPrefix = `${type}${delimiter}`;

  if (eventText) {
    if (eventTextPrefix) {
      return `${eventText}${delimiter}${namespace}`;
    } else {
      return `${namespace}${delimiter}${eventText}`;
    }
  }

  return `${namespace}${delimiter}${defaultPrefix}`;
};

export default generateTrackingValue;
